<template lang="pug">
  .wp-rich-text(v-html="htmlResolved")
</template>

<script>
import wpLinkResolver from '@/wp-link-resolver'
export default {
  name: 'WPRichText',
  props: {
    html: { type: String, default: '' }
  },
  computed: {
    htmlResolved () {
      return this.html && this.html.replace(/href="([^"]+)/g, (_, text) => 'href="' + wpLinkResolver(text))
    }
  }
}
</script>

<style>
</style>
